__turbopack_context__.v({
  "article": "kyEQcq_article",
  "aside": "kyEQcq_aside",
  "base": "kyEQcq_base",
  "block": "kyEQcq_block",
  "details": "kyEQcq_details",
  "div": "kyEQcq_div",
  "figcaption": "kyEQcq_figcaption",
  "figure": "kyEQcq_figure",
  "footer": "kyEQcq_footer",
  "header": "kyEQcq_header",
  "hgroup": "kyEQcq_hgroup",
  "menu": "kyEQcq_menu",
  "nav": "kyEQcq_nav",
  "section": "kyEQcq_section",
});
